import { BatchEditAction } from "../../../Reducers/Client/Interface/BatchEditReducer"
import { BatchEditType } from "../../Types"

export const enterBatchMode = (batchEditId: string): BatchEditAction => ({
    type: BatchEditType.enterBatchMode,
    meta: {
        id: batchEditId
    }
})

export const exitBatchMode = (batchEditId: string): BatchEditAction => ({
    type: BatchEditType.exitBatchMode,
    meta: {
        id: batchEditId
    }
})

export const addToSelection = (
    batchEditId: string,
    ids: string[]
): BatchEditAction => ({
    type: BatchEditType.addToSelection,
    meta: {
        id: batchEditId
    },
    payload: ids
})

export const removeFromSelection = (
    batchEditId: string,
    ids: string[]
): BatchEditAction => ({
    type: BatchEditType.removeFromSelection,
    meta: {
        id: batchEditId
    },
    payload: ids
})

export const clearSelection = (batchEditId: string): BatchEditAction => ({
    type: BatchEditType.clearSelection,
    meta: {
        id: batchEditId
    }
})

export const toggleSelection = (
    batchEditId: string,
    ids: string[]
): BatchEditAction => ({
    type: BatchEditType.toggleSelection,
    meta: {
        id: batchEditId
    },
    payload: ids
})
